import * as qs from 'qs';
import { Store } from '../../core/createStore';
import SignupUser from '../../entity/signupUser';
import UserRepository from '../../service/userRepository';

import {
  dispose,
  setUser,
} from '../../state/signup';
import User from '../../entity/user';

class Signup {
  private userRepository: UserRepository;
  private store: Store;

  constructor({
    userRepository,
    store,
  }: {
    userRepository: UserRepository;
    store: Store;
  }) {
    this.userRepository = userRepository;
    this.store = store;
  }

  public async initialize(): Promise<void> {
    this.store.dispatch(setUser(new SignupUser({})));
  }

  public updateSignupUserField(partial: Partial<SignupUser>): void {
    const current = this.store.getState().signup.user;
    const user = new SignupUser({ ...current, ...partial } as SignupUser);

    this.store.dispatch(setUser(user));
  }

  public async signup(): Promise<User> {
    const token = qs.parse(window.location.search.slice(1))['token'];
    const signupUser = this.store.getState().signup.user;

    if (!token || !signupUser) {
      throw new Error('It is cannot have reach here.');
    }

    try {
      return await this.userRepository.signup(
        token,
        signupUser,
      );
    } catch (err) {
      throw err;
    }
  }

  public dispose(): void {
    this.store.dispatch(dispose());
  }
}

export default Signup;
